(function () {
  if(window.__bwNeedsInitialized)return;
  window.__bwNeedsInitialized=true;
    'use strict';
    var instances=new Map();
    function initialize(root){
    if(instances.has(root))return;
    var controller=new AbortController();
    var listen=(node,event,handler)=>node.addEventListener(event,handler,{signal:controller.signal});
    instances.set(root,controller);
    var links = [].slice.call(root.querySelectorAll('[data-bw-need]'));
    var results = [].slice.call(root.querySelectorAll('.bw-needs__result'));
    function show(id, focus) {
      links.forEach(function (a) {
        if (a.getAttribute('data-bw-need') === id) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      results.forEach(function (r) { r.setAttribute('data-open', r.id === id ? 'true' : 'false'); });
      var open = results.find(function(r){return r.id===id;});
      if (open && focus) {
        open.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        open.focus({ preventScroll: true });
      }
    }
    links.forEach(function (a) {
      listen(a,'click', function (e) {
        e.preventDefault();
        var id = a.getAttribute('data-bw-need');
        if (history.replaceState) history.replaceState(null, '', '#' + id);
        show(id, true);
      });
    });
    root.querySelectorAll('[data-bw-change-goal]').forEach(function (link) {
      listen(link,'click', function (event) {
        event.preventDefault();
        var tile = root.querySelector('[data-bw-need][aria-current="true"]') || links[0];
        if (!tile) return;
        tile.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        tile.focus({ preventScroll: true });
      });
    });
    var current = (location.hash || '').replace('#', '');
    if (current && results.some(function(r){return r.id===current;})) show(current, false);
    listen(window,'hashchange', function () { show((location.hash || '').replace('#', ''), true); });
    }
    function mount(){document.querySelectorAll('[data-bw-needs]').forEach(initialize);}
    mount();document.addEventListener('shopify:section:load',mount);
    document.addEventListener('shopify:section:unload',function(e){for(var entry of instances){if(e.target.contains(entry[0])){entry[1].abort();instances.delete(entry[0]);}}});
  })();
